import { PhoenixGrid } from 'app/shared/components/grid/PhoenixGrid';
import { AvoidPageBreakInsideWrapper } from '@styles/StyledDiv';
import { colorTheme } from '@styles/muiTheme';
import { CreditReportGridColumns } from './CreditReportGridColumns';

interface ICreditReportGridData {
  tableName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
}
export const CreditReportGridData = ({ tableName, data }: ICreditReportGridData) => {
  const attachId = () => {
    let id = 0;
    for (const value of data) {
      value.id = id++;
    }
  };

  data && attachId();

  return (
    <AvoidPageBreakInsideWrapper>
        <PhoenixGrid
          withHeader
          noButton
          strict
          disableColumnMenu
          autoHeight
          autoRowHeight
          gridHighlighColor = {colorTheme.palette.secondary.main}
          paginationIconColor = {colorTheme.palette.common.black}
          titleFontWeight={600}
          gridBorderColor={colorTheme.palette.secondary.dark}
          columns={CreditReportGridColumns(tableName)}
          name={tableName}
          rows={data || []}
          pageSize={5}
        />
    </AvoidPageBreakInsideWrapper>
  );
};
